<!-- tabs.component.html -->
<div class="tabs-container">
  <div class="tab-buttons">
    @for (tab of tabs; track tab; let i = $index) {
      <button (click)="selectTab(i)" [class.active]="i === activeTabIndex">
        {{ tab.label }}
      </button>
    }
  </div>
  <div class="tab-content">
    <ng-container #container></ng-container>
  </div>
</div>
